import { render } from "./CreateMachine.vue?vue&type=template&id=1b071129"
import script from "./CreateMachine.vue?vue&type=script&lang=js"
export * from "./CreateMachine.vue?vue&type=script&lang=js"

import "./CreateMachine.vue?vue&type=style&index=0&id=1b071129&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__